export default function SubmissionStatusBanner({
  status,        // 'pending_review' | 'changes_requested' | 'rejected'
  adminNote,     // string | null
}) {
  if (!status) return null;

  const isPending = status === 'pending_review';
  const isChanges = status === 'changes_requested';
  const isRejected = status === 'rejected';

  let background = '#f3f4f6';
  let border = '#e5e7eb';
  let title = '';
  let description = '';

  if (isPending) {
    background = '#f8fafc';
    border = '#e5e7eb';
    title = 'Pending review';
    description =
      'Your event is currently under admin review. You can continue editing your submission while it’s pending.';
  }

  if (isChanges) {
    background = '#fff7ed';
    border = '#fed7aa';
    title = 'Changes requested';
    description =
      'An admin reviewed your submission and requested updates before it can be approved.';
  }

  if (isRejected) {
    background = '#fef2f2';
    border = '#fecaca';
    title = 'Submission rejected';
    description =
      'This event was reviewed and rejected. See the notes below for context.';
  }

  return (
    <div
      style={{
        background,
        border: `1px solid ${border}`,
        borderRadius: 12,
        padding: '12px 14px',
        marginBottom: 12,
      }}
    >
      <div
        style={{
          fontSize: 13,
          fontWeight: 900,
          marginBottom: 4,
          color: '#0b0b0b',
        }}
      >
        {title}
      </div>

      <div
        style={{
          fontSize: 13,
          color: '#374151',
          lineHeight: 1.45,
        }}
      >
        {description}
      </div>

      {(isChanges || isRejected) && adminNote && (
        <div
          style={{
            marginTop: 10,
            paddingTop: 10,
            borderTop: '1px solid #e5e7eb',
          }}
        >
          <div
            style={{
              fontSize: 12,
              fontWeight: 800,
              color: '#374151',
              marginBottom: 4,
            }}
          >
            Admin notes
          </div>

          <div
            style={{
              fontSize: 13,
              color: '#111827',
              whiteSpace: 'pre-wrap',
              lineHeight: 1.45,
            }}
          >
            {adminNote}
          </div>
        </div>
      )}
    </div>
  );
}
